export default "__VITE_ASSET__BovF0OaY__"